import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeShow = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 19.3077C8 19.3077 12.8 11 20 11C27.2 11 32 19.3077 32 19.3077C32 19.3077 27.2 27.6154 20 27.6154C12.8 27.6154 8 19.3077 8 19.3077Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 23C22.0392 23 23.6923 21.3469 23.6923 19.3077C23.6923 17.2685 22.0392 15.6154 20 15.6154C17.9608 15.6154 16.3077 17.2685 16.3077 19.3077C16.3077 21.3469 17.9608 23 20 23Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgEyeShow);
export default ForwardRef;
